import controller from './vd-radio.controller'
import template from './vd-radio.html'

const RadioComponent = {
  bindings: {
    value: '<',
    disabled: '<',
    label: '@',
    name: '@',
    description: '@',
  },
  require: {
    vdRadioGroupCtrl: '^vdRadioGroup',
  },
  transclude: true,
  template,
  controller,
}

export default RadioComponent
